import localforage from 'localforage'

const musicStore = localforage.createInstance({
  name: 'sound_care',
  version: 1.0,
  storeName: 'song_info_storage',
  description: 'Storage of downloaded song info',
})

const userStore = localforage.createInstance({
  name: 'sound_care_user',
  version: 1.0,
  storeName: 'user_info_storage',
  description: 'Storage of authenticated user info',
})

export const saveSongInfoToStore = (songInfo) => {
  return musicStore.setItem(songInfo.id, songInfo)
}

export const getSongInfoFromStore = (id) => {
  return musicStore.getItem(id)
}

export const deleteSongInfoFromStore = (id) => {
  return musicStore.removeItem(id)
}

export const saveGenresToStore = (genres) => {
  return musicStore.setItem('genres', genres)
}

export const getGenresFromStore = async () => {
  return (await musicStore.getItem('genres')) || []
}

export const saveUserInfoToStore = async (user) => {
  return await userStore.setItem('user', JSON.stringify(user))
}

export const getUserInfoFromStore = async () => {
  return JSON.parse(await userStore.getItem('user'))
}

export const deleteUserInfoFromStore = async () => {
  return await userStore.removeItem('user')
}
